module.exports = __webpack_public_path__ + "static/img/bbtsaxc-logo.e2165f2c.png";